import { Dispatch } from "react";

import { DoctorDto } from "@apiModels/DoctorDto.csharp";
import { ServiceDto } from "@apiModels/ServiceDto.csharp";
import { SpecializationDto } from "@apiModels/SpecializationDto.csharp";
import { AppointmentDto } from "@apiModels/AppointmentDto.csharp";
import { LocationDto } from "@apiModels/LocationDto.csharp";
import { RemoteContactViewModel } from "@apiModels/RemoteContactViewModel.csharp";
import { CreateBookingResponseDto } from "@apiModels/CreateBookingResponseDto.csharp";
import { BookingCancellationDeadlineDto } from "@apiModels/BookingCancellationDeadlineDto.csharp";
import { ServiceGroupDto } from "@apiModels/ServiceGroupDto.csharp";
import { MissingAppointmentsDto } from "@apiModels/MissingAppointments/MissingAppointmentsDto.csharp";
import { RelatedServiceSetup } from "@apiModels/RelatedServiceSetup.csharp";
import { ServicePricingSummary } from "../../../Partials/PricingHighlight/ServicePricingSummary.csharp";

export enum FormReducer {
  clear = "clearField",
  update = "update",
}

export enum FormFields {
  "specialization" = "specialization",
  "service" = "service",
  "serviceGroup" = "serviceGroup",
  "location" = "location",
  "doctor" = "doctor",
  "selectedDay" = "selectedDay",
  "selectedMonth" = "selectedMonth",
  "appointment" = "appointment",
  "bookingResponse" = "bookingResponse",
  "bookingSessionId" = "bookingSessionId",
  "currentStep" = "currentStep",
  "remoteContact" = "remoteContact",
  "pricingSummary" = "pricingSummary",
  "cancellationDeadline" = "cancellationDeadline",
  "missingAppointments" = "missingAppointments",
  "wasDifferentTimeZoneModalShown" = "wasDifferentTimeZoneModalShown",
  "relatedServiceSetups" = "relatedServiceSetups",
  "showRelatedServices" = "showRelatedServices",
  "showRelatedServicesMap" = "showRelatedServicesMap",
}

export type FormStateType = {
  [key: string]: any;
  location: LocationDto;
  specialization: SpecializationDto;
  service: ServiceDto;
  serviceSecondLevel: ServiceDto;
  serviceGroup: ServiceGroupDto;
  doctor: DoctorDto;
  selectedDay: string;
  selectedMonth: string;
  appointment: AppointmentDto;
  missingAppointments: MissingAppointmentsDto;
  bookingResponse: CreateBookingResponseDto;
  currentStep: number;
  remoteContact: RemoteContactViewModel;
  pricingSummary: ServicePricingSummary;
  cancellationDeadline?: BookingCancellationDeadlineDto;
  bookingSessionId: string;
  wasDifferentTimeZoneModalShown: boolean;
  relatedServiceSetups: RelatedServiceSetup[];
  showRelatedServicesMap: Map<number, boolean>;
};

export type Action = {
  type: FormReducer;
  field: FormFields;
  payload?: any;
};

export type FormDispatch = Dispatch<Action>;
